import { render } from "./WorkspaceDeleteConfirm.vue?vue&type=template&id=a44cb574&scoped=true&bindings={\"activeWorkspace\":\"options\",\"cancel\":\"options\",\"deleteWorkspace\":\"options\"}"
import script from "./WorkspaceDeleteConfirm.vue?vue&type=script&lang=js"
export * from "./WorkspaceDeleteConfirm.vue?vue&type=script&lang=js"

import "./WorkspaceDeleteConfirm.vue?vue&type=style&index=0&id=a44cb574&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a44cb574"

export default script